import { render } from "./ClusterLegend.vue?vue&type=template&id=96c5be1e"
import script from "./ClusterLegend.vue?vue&type=script&lang=ts"
export * from "./ClusterLegend.vue?vue&type=script&lang=ts"
script.render = render

export default script